// apiConfig.js
export const API_BASE_URLS = {
  ADMIN_SERVICE: "http://52.172.150.112:8087",
  CLIENT_SERVICE: "http://52.172.150.112:8080",
  NAPID_AUTH_SERVICE: "http://52.172.150.112:8085",
};
